// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cardContainerMultiColumnStyles } from "@insite/content-library/Components/CardContainerMultiColumn";
import { css } from "styled-components";

cardContainerMultiColumnStyles.cardDivider = {
    css: css`
        height: 100%;
        width: 100%;
        overflow: hidden;
        border-bottom: 0;
        display: flex;
    `,
};

cardContainerMultiColumnStyles.gridItem = {
    width: [12, 6, 6, 4, 4],
};
